import { render, staticRenderFns } from "./productBatchReport.vue?vue&type=template&id=40f2b7af&scoped=true&"
import script from "./productBatchReport.vue?vue&type=script&lang=js&"
export * from "./productBatchReport.vue?vue&type=script&lang=js&"
import style0 from "./productBatchReport.vue?vue&type=style&index=0&id=40f2b7af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f2b7af",
  null
  
)

export default component.exports